import { APIPost, APIPostV1 } from './http';
import { IFetchData } from '../_types/post';
import { ISearchResult } from '../_types/search';
import { IEquipmentManifest, IInterfaceConfig, IEquipment, IInterface, IQRScanMemberRequest, IQRScanAdminRequest, IQRScanResult } from '../_types/location';
import { ILocationSummary } from '../_types/user';
import { PolicyObjectTypeOptions } from '../_types/ewpolicy';
import { IUser } from "../_types/user";


const _interfaceConfigs: IInterfaceConfig[] = [
    {
        name: "cryptopay",
        instructions: "",
        triggers: ["interfacetrigger.remotescan", "interfacetype.scanner", "interfacetype.finger"],
        types: ["interfacetype.paystation", "interfacetype.unit"]
    },
    {
        name: "washcard",
        instructions: "",
        triggers: ["interfacetrigger.remotescan"],
        types: ["interfacetype.unit"]
    },
    {
        name: "washify",
        instructions: "",
        triggers: ["interfacetype.scanner", "interfacetype.finger"],
        types: ["interfacetype.paystation"]
    },
    {
        name: "touch4wash",
        instructions: "",
        triggers: ["interfacetrigger.remotescan"],
        types: ["interfacetype.unit"]
    },
    {
        name: "coinless",
        instructions: "",
        triggers: ["interfacetrigger.remotescan"],
        types: ["interfacetype.unit"]
    },
    {
        name: "unitec",
        instructions: "",
        triggers: ["interfacetrigger.remotescan", "interfacetype.scanner", "interfacetype.finger"],
        types: ["interfacetype.paystation", "interfacetype.unit"]
    },
    {
        name: "xpreswash",
        instructions: "",
        triggers: ["interfacetrigger.remotescan"],
        types: ["interfacetype.unit"]
    },
    {
        name: "nayax",
        instructions: "",
        triggers: ["interfacetrigger.remotescan"],
        types: ["interfacetype.unit"]
    }

]

// Keep in sync with Proxy::ATHENA_REMOTE_START_PROVIDERS in the PHP API.
export const ATHENA_REMOTE_START_PROVIDERS: string[] = [
    "nayax"
];

export const UsesAthenaRemoteStart = (providerName?: string | null): boolean => {
    if (!providerName) {
        return false;
    }

    return ATHENA_REMOTE_START_PROVIDERS.includes(providerName.trim().toLowerCase());
}

export const ListInterfaceConfigs = () => {

}

export const DefaultManifest: IEquipmentManifest = {

    equipment: [],
    interfaces: [],
    plans: []
   
}
export const DefaultEquipment: IEquipment = {
    deleted: false,
    enabled: false,
    service_location_uuid: null,
    name: "New Equipment",
    editing: false,
    equipment_type_cn: "equipmenttype.iba",
    id: 0,
    selected: false,
    service_location_id: 0
}

export const DefaultInterface: IInterface = {
    deleted: false,
    service_location_uuid: null,
    editing: false,
    equipment: [],
    id: 0,
    interface_type_cn: "interfacetype.unit",
    model: "",
    provider_name: "",
    selected: false,
    service_location_id: 0,
    triggers: []
};

export const SaveEquipment = async (equip:IEquipment): Promise<IEquipment> => {

    let toReturn = DefaultEquipment;

    if (equip.name !== null) {
        equip.name = equip.name.trim();
    }

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "remotestart",
        relay_to: "/interface/saveequipment",
        ...equip
    };

    let result = await APIPost<IEquipment>(post);

    if (result) { toReturn = result;}

    return toReturn;

}

export const SaveInterface = async (iface:IInterface): Promise<IInterface> => {
    let toReturn = DefaultInterface;

    iface.equipment.forEach((equipmentInterface) => {
        if (equipmentInterface.qrcode) {
            equipmentInterface.qrcode = equipmentInterface.qrcode.trim();
        }

        if (equipmentInterface.text_code) {
            equipmentInterface.text_code = equipmentInterface.text_code.trim();
        }

        if (equipmentInterface.remote_config) {
            let newEquipmentObject = JSON.parse(equipmentInterface.remote_config);
            if (newEquipmentObject.SiteId) { newEquipmentObject.SiteId = newEquipmentObject.SiteId.trim(); }
            if (newEquipmentObject.DeviceId) { newEquipmentObject.DeviceId = newEquipmentObject.DeviceId.trim(); }
            if (newEquipmentObject.TerminalId) { newEquipmentObject.TerminalId = newEquipmentObject.TerminalId.trim(); }
            if (newEquipmentObject.UniQR) { newEquipmentObject.UniQR = newEquipmentObject.UniQR.trim(); }
            equipmentInterface.remote_config = JSON.stringify(newEquipmentObject);
        }


    })

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "remotestart",
        relay_to: "/interface/saveinterface",
        ...iface
    };

    let result = await APIPost<IInterface>(post);

    if (result) { toReturn = result;}

    return toReturn;

}

export const TestRemoteStart = async (config: IQRScanAdminRequest, providerName?: string): Promise<IQRScanResult> => {

    let toReturn: IQRScanResult = { 
        one_time_use_code: null,
        remote_start: {
            instructions: "Nothing Happened"
        }
    };

    let result: IQRScanResult | null;

    if (UsesAthenaRemoteStart(providerName)) {
        let response = await APIPostV1<{ success: IQRScanResult }>({
            endpoint: "/1/admin/payment/test_remote_start",
            authorize: true,
            method: "POST"
        }, config);

        result = response ? response.success : null;
    } else {
        let post: IFetchData = {
            authorize: true,
            method: "POST",
            refresh: false,
            service: "remotestart",
            relay_to: "/interface/scan_qr_admin",
            ...config
        };

        result = await APIPost<IQRScanResult>(post);
    }

    if (result) { toReturn = result;}

    return toReturn;

}

interface IRemoteStartV1Response {
    success: IQRScanResult;
}

export const RemoteStart = async (config: IQRScanMemberRequest): Promise<IQRScanResult | null> => {
    const result = await APIPostV1<IRemoteStartV1Response>({
        authorize: true,
        endpoint: "/1/admin/payment/start_remote_start",
        method: "POST"
    }, {
        membership_id: config.membership_id,
        qrcode: config.equipment_id
    });

    return result && result.success ? result.success : null;
}

export const GetEquipmentInterface = async (service_location_id: number): Promise<IEquipmentManifest> => {

    let toReturn = DefaultManifest;

    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "remotestart",
        relay_to: "/interface/getequipmentbylocation/" + service_location_id
    };
    

    let result = await APIPost<IEquipmentManifest>(post);

    if (result) { toReturn = result; }

    return toReturn;

}

export const GetLocation = async (id: number): Promise<ILocationSummary | null> => {


    let post: IFetchData = {
        authorize: true,
        method:"GET",
        refresh: false,
        service: "ewapi",
        relay_to: "/wash/getlocation/" + id        
    };
    

    let result = await APIPost<ILocationSummary | null>(post);

    if (result !== null) {
        result.objectType = PolicyObjectTypeOptions.servicelocation;
        result.displayName = result.name;
    }
    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    
    return result;

}


export const SearchLocations = async (query: string, role?: number | null): Promise<ISearchResult[] | null> => {
    const postObj = { 
        query: query,
        includeRemoved: true,
        includeDeleted: true
    };

    const serviceLocationsResults: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/wash/searchlocations",
        ...postObj
    };

    let result = await APIPost<ISearchResult[] | null>(serviceLocationsResults);

    if (query.length > 4 && (result===null || result.length===0) && ((role === 4))) {
        //if nothing returned from searching by wash name and this is an admin, then search by guid (qrcode in WashEquipmentInterface).  This should prevent unneeded searching
        const guidResults: IFetchData = {
            authorize: true,
            method:"POST",
            refresh: false,
            service: "ewapi",
            relay_to: "/wash/searchlocationsbyqrcode",
            ...postObj
        };
        result = await APIPost<ISearchResult[]>(guidResults);
    }
    
    return result;

}

export const AddGiftCardCodes = async (serviceLocationId: number, amount: number, codes: string[]): Promise<any | null> => {

    let postObj = {
        serviceLocationId: serviceLocationId,
        dollarAmount: amount,
        codes: codes
    }

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/location/upload_giftcodes",
       ...postObj
    }

    let result = await APIPost<string>(post);

    return result;
}

export const DeleteEquipment = async (equipmentId: number): Promise<IEquipmentManifest | null> => {
    let postObj = {
        EquipmentId: equipmentId
    };

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "remotestart",
        relay_to: "/interface/deleteequipment",
        ...postObj
    };
    
    let result = await APIPost<IEquipmentManifest>(post);
    
    return result;
}

export const DeleteInterface = async (interfaceId: number): Promise<IEquipmentManifest | null> => {
    let postObj = {
        InterfaceId: interfaceId
    };

    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "remotestart",
        relay_to: "/interface/deleteinterface",
        ...postObj
    };
    
    let result = await APIPost<IEquipmentManifest>(post);
    
    return result;
}
